// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B5fg","colBig":"styles_colBig__1F5Vh","colSmall":"styles_colSmall__2PsJC"};